import React from 'react';
import DocumentHeader from '../components/DocumentHeader';
import {getBrandName} from '../components/Brand';

const GuidelinesPage = () => (
  <div>
    <DocumentHeader title="Community Guidelines" />
    <div className="mx-auto max-w-3xl px-4 pt-10 pb-20">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">Community Guidelines</h1>
      <p className="mb-6">
        {`${getBrandName()} is committed to fostering a
        welcoming and inclusive community for everyone.
        These guidelines are designed to ensure respectful interactions
        and help guide appropriate behavior across all user submissions,
        content, and engagements on the platform.`}
      </p>
      <h2 className="text-2xl font-semibold text-gray-900 mb-4">Harassment and Respect</h2>
      <p className="mb-4">
        Our community is diverse, and we expect all members to
        engage with one another respectfully. This means
        treating others&apos; beliefs, interests, and
        communication styles with professionalism and
        consideration. Candid feedback is encouraged,
        but harassment in any form will not be tolerated,
        including but not limited to:
      </p>
      <ul className="list-disc pl-6 mb-4">
        <li>Bullying, personal attacks, or derogatory remarks</li>
        <li>Objectifying or sexualizing individuals</li>
        <li>Discriminatory language or hate speech</li>
      </ul>
      <p className="mb-6">
        Hate speech refers to any comments or content that
        express prejudice or incite hatred against individuals or
        groups based on race, ethnicity, religion, disability, age,
        veteran status, sexual orientation, gender, or gender identity.
      </p>
      <h2 className="text-2xl font-semibold text-gray-900 mb-4">Privacy and Confidentiality</h2>
      <p className="mb-4">
        Protecting privacy is paramount. Do not share personally
        identifiable information (PII) of others without their consent.
        This includes personal details of other members or information
        shared in confidence during interactions.
      </p>
      <ul className="list-disc pl-6 mb-6">
        <li>Publicly available information (e.g., news about public figures) may be discussed.</li>
        <li>
          If you encounter violations of privacy or sensitive information
          being shared, please report it immediately.
        </li>
      </ul>
      <h2 className="text-2xl font-semibold text-gray-900 mb-4">Relevance and Integrity</h2>
      <p className="mb-6">
        All interactions and submissions should contribute meaningfully
        to the community&apos;s purpose. Whether sharing experiences, providing feedback,
        or asking questions, ensure your contributions reflect real-life interview
        preparation and professional standards.
      </p>
      <h2 className="text-2xl font-semibold text-gray-900 mb-4">Inappropriate Content</h2>
      <p className="mb-6">
        Offensive or inappropriate content is prohibited. This includes,
        but is not limited to, explicit, unlawful, or excessively graphic
        material. Keep discussions professional and avoid profanity where possible.
      </p>
      <h2 className="text-2xl font-semibold text-gray-900 mb-4">Spam and Solicitation</h2>
      <p className="mb-6">
        The community values authentic contributions. Avoid submitting
        repetitive, irrelevant, or promotional content. Unsolicited promotions,
        phishing attempts, or advertising of products or services are strictly prohibited.
      </p>
      <h2 className="text-2xl font-semibold text-gray-900 mb-4">Impersonation</h2>
      <p className="mb-6">
        Misrepresenting yourself or impersonating another person or
        organization is unacceptable. Whether through usernames or interactions,
        be honest about your identity.
      </p>
      <h2 className="text-2xl font-semibold text-gray-900 mb-4">Reporting Violations</h2>
      <p className="mb-6">
        If you see content or interactions that violate these guidelines,
        please flag it for review. Violations may result in suspension or
        removal from the platform to ensure the safety and
        comfort of all members.
      </p>
      <p>
        {`Thank you for upholding these guidelines and making ${getBrandName()} a
        respectful, professional space for all.`}
      </p>
    </div>
  </div>
);

export default GuidelinesPage;
